import { t } from "app/utils";

import { queryKey as departmentQueryKey } from "components/filters/DepartmentFilter";
import { queryKey as interestQueryKey } from "components/filters/InterestFilter";
import { queryKey as locationQueryKey } from "components/filters/LocationFilter";

const inviteTypes = {
  users: {
    name: t("User"),
    icon: "ios-person",
    key: "userIds"
  },
  departments: {
    name: t("Department"),
    icon: "ios-people",
    key: "departmentIds",
    link: departmentQueryKey
  },
  interests: {
    name: t("Interest"),
    icon: "heart",
    key: "interestIds",
    link: interestQueryKey
  },
  skills: {
    name: t("Skill"),
    icon: "hammer",
    key: "skillIds"
  },
  locations: {
    name: t("Location"),
    icon: "ios-location",
    key: "locationIds",
    link: locationQueryKey
  },
  companies: {
    name: t("Company"),
    icon: "building",
    key: "companyIds",
    link: locationQueryKey
  },
  organizations: {
    name: t("Organization"),
    icon: "building-filled",
    key: "organizationIds"
  }
};

export default inviteTypes;
